@if (fabTogglerState === 'active') {
<div id="fab-dismiss" (click)="toggle()"></div>
}

<div class="fab-container" [ngClass]="{ hidden: hidden }">
  <button mat-fab class="fab-toggler button-red" [disabled]="disabled" (click)="toggle()">
    <i class="material-icons" [@fabToggler]="{ value: fabTogglerState }">add</i>
  </button>

  <div [@speedDialStagger]="buttons.length">
    <mat-chip-listbox *transloco="let t" class="mat-chip-list-stacked">
      @for (btn of buttons; track btn) {
      <mat-chip-option
        class="button-secondary chip-button"
        (click)="!btn.disabled && btn.action(); toggle()"
        [matTooltip]="btn.tooltip | sibatTranslate : t"
        [class.disabled]="btn.disabled"
        [class.has-icon]="!!btn.icon"
      >
        @if (btn.icon) {
        <mat-icon matChipAvatar>{{ btn.icon }}</mat-icon>
        }
        <span>{{ btn.label | sibatTranslate : t }}</span>
      </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
</div>
